import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <defs>
      <linearGradient
        id="instagram_svg__a"
        x1="7.821%"
        x2="90.816%"
        y1="91.246%"
        y2="9.417%"
      >
        <stop offset="0%" stopColor="#FFAA1B" />
        <stop offset="53.324%" stopColor="#DA012C" />
        <stop offset="100%" stopColor="#C0009B" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect
        width={23.865}
        height={23.865}
        x={0.097}
        fill="url(#instagram_svg__a)"
        rx={11.933}
      />
      <g transform="translate(4.806 4.806)">
        <rect
          width={12.563}
          height={12.615}
          x={0.934}
          y={0.945}
          stroke="#FFF"
          rx={6}
        />
        <circle cx={7.141} cy={7.153} r={3.106} stroke="#FFF" />
        <circle cx={10.975} cy={3.369} r={1} fill="#FFF" />
      </g>
    </g>
  </svg>
);
const Memo = memo(SvgInstagram);
export default Memo;
